import vmClient from 'app/services/vmClient';
import { Entity, IEntityType, IEntity, EntityStringId } from 'app/types/entity';

export interface IInternalTag extends IEntity {
  attributes: {
    id: EntityStringId;
    name: string | null;
  };
}

export type InternalTag = Entity<IInternalTag>;
// defineClass is a class factory, normally classes create a runtime variable and identifier in the type namespace.
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InternalTag: IEntityType<IInternalTag> = vmClient.defineClass({
  typeName: 'InternalTag',
  version: 1,
  persisted: true,
  attributes: {
    name: 'string',
  },
});
